import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(_Circle, { cx: "13", cy: "12", r: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 19c-2.8 0-5-2.2-5-5v8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "20", cy: "19", r: "2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FolderGit2";
const FolderGit2 = memo(themed(Icon));
export {
  FolderGit2
};
//# sourceMappingURL=folder-git-2.js.map
